import { Property } from './interfaces';

export const codDiagnosticoCausaMuerte: Property = {
  title: "Código de Diagnóstico Causa de Muerte",
  type: "string",
};
